import React from "react";
import { Container } from "react-bootstrap";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";

const RiskPage = ({ state }) => (
  <Layout
    title="Stride Equity - General CSF Risk Warning"
    meta={{
      card: "summary_large_image",
      description:
        "Crowd-sourced funding is risky. Issuers using this facility include new or rapidly growing ventures. Investment in these types of ventures is speculative and carries high risks.",
    }}
    state={state}
  >
    <div className="offset-header service-page">
      <Container className="pt-5 container-wrp">
        <h1>General CSF Risk Warning</h1>
        <hr />
        <div className="service-content-wrapper">
          <p>
            Crowd-sourced funding is risky. Issuers using this facility include
            new or rapidly growing ventures. Investment in these types of
            ventures is speculative and carries high risks.
          </p>
          <p>
            You may lose your entire investment, and you should be in a position
            to bear this risk without undue hardship.
          </p>
          <p>
            Even if the company is successful, the value of your investment and
            any return on the investment could be reduced if the company issues
            more shares.
          </p>
          <p>
            Your investment is unlikely to be liquid. This means you are
            unlikely to be able to sell your shares quickly or at all if you
            need the money or decide that this investment is not right for you.
          </p>
          <p>
            Even though you have remedies for misleading statements in the offer
            document or misconduct by the company, you may have difficulty
            recovering your money.
          </p>
          <p>
            There are rules for handling your money. However, if your money is
            handled inappropriately or the person operating the platform on
            which this offer is published becomes insolvent, you may have
            difficulty recovering your money.
          </p>
          <p>
            Ask questions, read all information given carefully, and seek
            independent financial advice before committing yourself to any
            investment.
          </p>
        </div>
      </Container>
    </div>
  </Layout>
);

export async function getServerSideProps({ req, res }) {
  return {
    props: {
      state: await ServerProps.getState(req),
    },
  };
}

export default RiskPage;
